// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"82fc8b0d","677":"fba539cd","740":"04a8e23b"}[chunkId] + ".chunk.js";
};